import $ from "jquery";
import fb from "../../core/firebase";
import bdjs from "../../core/bdjs";
import Handlebars from "handlebars";
import screen from "../../utils/screen";

export const WaitingRoom = async () => {
	const waitingRoom = $("#waiting-room");
	if (waitingRoom.length === 0) return false;
	if (!window.CFG.data.auth_token) return false;

	const $elems = {
		waitingRoom: $("#waiting-room"),
		timerDisplay: $("#timer-display"),
		timerIcon: $(".indicator__item-icon-timer"),
		questionWrapper: $("#question-wrapper"),
		fileWrapper: $("#file-wrapper"),
		btnBackToWaitingRoom: $("#btn-back-to-waiting-room"),
		btnBackToQuestion: $("#btn-back-to-question"),
		// btnShowQuestion: $(".btn-show-question"), //TODO: change this
		btnOpenCareDossier: $("#btn-open-care-dossier"),
		btnOpenCureDossier: $("#btn-open-cure-dossier"),
		btnExpand: $(".btn-expand"),
		btnFileListItem: $(".btn-file-list-item"),
		btnOpenPatient: $(".btn-open-patient"),
		popupNewPatient: $(".popup-new-patient"),
		popupPatientLeave: $(".popup-patient-leave"),
		btnCloseNewPatient: $("#btn-close-new-patient"),
		btnClosePatientLeave: $("#btn-close-patient-leave"),
		btnCloseNotification: $(".btn-close-notification"),
		popupNotification: $("#popup-notification"),
		popupPatientResult: $("#popup-patient-result"),
		btnClosePopupPatientResult: $("#btn-close-popup-patient-result"),
		workaroundButtonWrapper: $("#workaround-button-wrapper"),
		workaroundButtonText: $("#workaround-button-text"),
		btnOpenWorkaroundWarning: $("#btn-open-workaround-warning"),
		popupWarningWorkaround: $("#popup-warning-workaround"),
		btnCancelWorkaround: $("#btn-cancel-workaround"),
		btnContinueWorkaround: $("#btn-continue-workaround"),
		popupWorkaroundResult: $("#popup-workaround-result"),
		btnClosePopupWorkaroundResult: $("#btn-close-popup-workaround-result"),
		endScreen: $("#end-screen"),
		eventPopup: $(".event-popup"),
	}

	let firebase = fb();
	let timerInterval = null;
	let timerStarted = false;
	let serverTimeOffset = 0;
	let timerStart = null;
	let previousElapsedSeconds = -1;
	let lastTimerStartValue = null;
	let lastTimerEndValue = null;
	let gameFinished = false;
	// Sorted list of team player user IDs (from Firebase), used to pick one random player per event
	let teamPlayerIds = null;

	// Queue for new-patient / patient-leave popups (show one after another)
	let patientEventPopupQueue = [];
	let patientEventPopupShowing = false;
	let patientEventPopupTimeoutId = null;
	let currentPatientEventType = null; // 'new' | 'leave'

	// Queue for notification popup when question is open (new patient / patient leave)
	let notificationPopupQueue = [];
	let notificationPopupShowing = false;
	let notificationPopupTimeoutId = null;

	// Track which questions have been shown/hidden
	const questionStates = new Map();

	// Track which events have been shown/hidden (by elapsed time)
	const eventStates = new Map();

	// Track active patients (using Set to ensure uniqueness)
	const activePatientsSet = new Set();

	// Get questions from all patients with patient info attached
	const patients = window.CFG.data.patients || [];

	// Get active events (start_time_seconds and timer_seconds in seconds)
	const events = (window.CFG.data.events || []).filter((e) => e.is_active);


	const questions = patients.flatMap(patient => {

		if (!patient.questions || !Array.isArray(patient.questions)) {
			return [];
		}
		// Add patient info to each question
		return patient.questions.map(question => ({
			...question,
			patientId: patient.ID,
			patientName: patient.name,
			patientFullName: patient.full_name
		}));
	});


	const formatTime = (seconds) => {
		const mins = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
	}

	const updatePatientTimer = (patientId, elapsedSeconds, startTime, duration) => {
		// Calculate elapsed time for this question (add 1 to match adjusted timing)
		const questionElapsed = Math.max(0, (elapsedSeconds + 1) - startTime);
		const percentage = Math.min(100, Math.round((questionElapsed / duration) * 100));

		// Update the timer class
		const $timer = $(`.btn-open-patient[data-patient-id="${patientId}"] .patients__person-timer`);

		// Remove all at-* classes
		$timer.removeClass((index, className) => {
			return (className.match(/\bat-\d+\b/g) || []).join(' ');
		});

		// Add new percentage class
		$timer.addClass(`at-${percentage}`);
	}

	const updateQuestionTimer = (elapsedSeconds) => {
		// Get the current question ID from the question wrapper or file wrapper
		const questionId = parseInt($elems.questionWrapper.attr('data-question-id')) || parseInt($elems.fileWrapper.attr('data-question-id'));
		if (!questionId) return;

		// Find the question state to get timing information
		const questionState = questionStates.get(questionId);
		if (!questionState) return;

		const startTime = questionState.startTime;
		const endTime = questionState.endTime;
		const duration = endTime - startTime;

		// Calculate elapsed time for this question (add 1 to match adjusted timing)
		const questionElapsed = Math.max(0, (elapsedSeconds + 1) - startTime);
		const percentage = Math.min(100, Math.round((questionElapsed / duration) * 100));

		// Update the timer class in the question view
		const $timer = $elems.questionWrapper.find('.patient__timer');
		const $fileTimer = $elems.fileWrapper.find('.file__timer');

		// Remove all at-* classes
		$timer.removeClass((index, className) => {
			return (className.match(/\bat-\d+\b/g) || []).join(' ');
		});
		$fileTimer.removeClass((index, className) => {
			return (className.match(/\bat-\d+\b/g) || []).join(' ');
		});
		// Add new percentage class
		$timer.addClass(`at-${percentage}`);
		$fileTimer.addClass(`at-${percentage}`);
	}

	const updateEventTimer = (elapsedSeconds) => {
		const eventId = $elems.eventPopup.attr('data-event-id');
		if (!eventId) return;
		const state = eventStates.get(parseInt(eventId));
		if (!state) return;
		const duration = state.endTime - state.startTime;
		const eventElapsed = Math.max(0, (elapsedSeconds + 1) - state.startTime);
		const remainingSeconds = Math.max(0, duration - eventElapsed);
		const percentage = duration ? Math.min(100, Math.round((eventElapsed / duration) * 100)) : 100;
		const $timer = $elems.eventPopup.find('.event-popup__timer');
		const $timerInner = $elems.eventPopup.find('.event-popup__timer-inner');
		$timer.removeClass((index, className) => (className.match(/\bat-\d+\b/g) || []).join(' '));
		$timer.addClass(`at-${percentage}`);
		$timerInner.text(remainingSeconds);
	}

	const showEvent = (event) => {
		$elems.eventPopup.attr('data-event-id', event.ID);
		$elems.eventPopup.find('.event-popup__content-title').text(event.title || '');
		$elems.eventPopup.find('.event-popup__content-description').html(event.description || '');
		const duration = parseInt(event.timer_seconds) || 0;
		$elems.eventPopup.find('.event-popup__timer-inner').text(duration);
		$elems.eventPopup.find('.event-popup__timer').removeClass((index, className) => (className.match(/\bat-\d+\b/g) || []).join(' ')).addClass('at-0');
		$elems.eventPopup.addClass('is-open');
		$elems.waitingRoom.addClass('blur');
	}

	const hideEvent = (dismissedByUser = false) => {
		const eventId = $elems.eventPopup.attr('data-event-id');
		if (dismissedByUser && eventId) {
			const state = eventStates.get(parseInt(eventId));
			if (state) state.hidden = true;
		}
		$elems.eventPopup.removeClass('is-open');
		$elems.waitingRoom.removeClass('blur');
		$elems.eventPopup.removeAttr('data-event-id');
	}

	// Deterministic "random" choice: same event + team always picks the same player (all clients agree)
	const getChosenPlayerIdForEvent = (eventId) => {
		if (!teamPlayerIds || teamPlayerIds.length === 0) return null;
		const teamCode = (window.CFG.data.game_progress && window.CFG.data.game_progress.team_code || '').toUpperCase();
		const seed = String(teamCode + eventId).split('').reduce((a, c) => a + c.charCodeAt(0), 0);
		const index = Math.abs(seed) % teamPlayerIds.length;
		return teamPlayerIds[index];
	};

	const isCurrentPlayerChosenForEvent = (eventId) => {
		const chosenId = getChosenPlayerIdForEvent(eventId);
		if (chosenId == null) return false;
		return String(window.CFG.user_id) === String(chosenId);
	};

	const checkEventTimings = (elapsedSeconds) => {
		events.forEach((event) => {
			const eventId = event.ID;
			const startTime = parseInt(event.start_time_seconds) || 0;
			const duration = parseInt(event.timer_seconds) || 0;
			if (!duration) return;
			const endTime = startTime + duration;
			const isChosen = isCurrentPlayerChosenForEvent(eventId); //only the chosen player will see the event

			if (!eventStates.has(eventId)) {
				const initialShown = isChosen && elapsedSeconds + 1 >= startTime && elapsedSeconds < endTime;
				const initialHidden = elapsedSeconds >= endTime;
				eventStates.set(eventId, {
					shown: initialShown,
					hidden: initialHidden,
					startTime,
					endTime
				});
				if (initialShown && !initialHidden && event.is_active) {
					showEvent(event);
					updateEventTimer(elapsedSeconds);
				}
				return;
			}

			const state = eventStates.get(eventId);
			if (state.hidden) return;

			if (isChosen && elapsedSeconds + 1 >= startTime && elapsedSeconds < endTime && !state.shown && event.is_active) {
				showEvent(event);
				state.shown = true;
			}

			if ($elems.eventPopup.hasClass('is-open')) {
				updateEventTimer(elapsedSeconds);
			}

			if (elapsedSeconds >= endTime && !state.hidden) {
				hideEvent();
				state.hidden = true;
			}
		});
	}

	const checkQuestionTimings = (elapsedSeconds) => {
		// Process each patient separately for sequential question timing
		patients.forEach((patient) => {
			// Skip patients without timing configuration
			if (!patient.start_time_seconds || patient.start_time_seconds === null) {
				return;
			}

			// Skip patients without questions
			if (!patient.questions || !Array.isArray(patient.questions) || patient.questions.length === 0) {
				return;
			}

			const patientId = patient.ID;
			const patientStartTime = parseInt(patient.start_time_seconds);
			const breakTimeSeconds = parseInt(patient.break_time_seconds) || 0;

			// Calculate timing for all questions sequentially
			let currentStartTime = patientStartTime;

			for (let i = 0; i < patient.questions.length; i++) {
				const question = patient.questions[i];
				const questionId = question.question || question.ID || question.id || 'unknown';
				const duration = parseInt(question.timer_seconds) || 0;

				if (!duration) continue;

				// Initialize question state if needed
				if (!questionStates.has(questionId)) {
					const cachedAnswer = answeredQuestionsCache[String(questionId)];
					const isAnswered = !!cachedAnswer;

					// Check if question already timed out
					const cachedTimeout = timeoutQuestionsCache[String(questionId)];
					const isTimedOut = !!cachedTimeout;

					// Extract answered_at timestamp if available (could be old format with just answer_id)
					let answeredAt = null;
					if (cachedAnswer && typeof cachedAnswer === 'object' && cachedAnswer.answered_at) {
						answeredAt = cachedAnswer.answered_at;
					}

					const calculatedEndTime = currentStartTime + duration;

					// Determine initial shown/hidden state based on elapsed time (for page reloads)
					let initialShown = false;
					let initialHidden = false;

					// If question already timed out (from cache), mark as timed out
					if (isTimedOut) {
						initialShown = true;
						initialHidden = true;
					}
					// If we're past the end time and question wasn't answered, mark as timed out
					else if (elapsedSeconds >= calculatedEndTime && !isAnswered) {
						initialShown = true;
						initialHidden = true;
					}
					// If we're between start and end time, mark as currently shown
					else if (elapsedSeconds >= currentStartTime && elapsedSeconds < calculatedEndTime && !isAnswered) {
						initialShown = true;
					}

					questionStates.set(questionId, {
						shown: initialShown,
						hidden: initialHidden,
						answered: isAnswered,
						answeredAt: answeredAt,
						timedOut: isTimedOut,
						patientId: patientId,
						startTime: currentStartTime,
						endTime: calculatedEndTime,
						questionIndex: i
					});

					// If question should be shown during initialization (page reload in active window)
					if (initialShown && !initialHidden && !isAnswered && !isTimedOut) {
						showPatient(patientId, question, true); // Pass true to indicate this is a reload
						// Update timer immediately for page reloads
						updatePatientTimer(patientId, elapsedSeconds, currentStartTime, duration);
					}
				}

				const questionState = questionStates.get(questionId);

				// If this question was answered, calculate when it was answered
				// and use that to determine the start time for the next question
				if (questionState.answered) {
					// Question was answered, so next question starts after break time
					if (questionState.answeredAt) {
						currentStartTime = questionState.answeredAt + breakTimeSeconds;
					} else {
						// We don't know when it was answered (loaded from cache on page load)
						// Assume it ended at its natural end time
						currentStartTime = questionState.endTime + breakTimeSeconds;
					}
					continue; // Move to next question
				}

				// If this question was already timed out (from cache or expired) on page load,
				// skip to the next question
				if (questionState.timedOut || (questionState.hidden && !questionState.answered)) {
					currentStartTime = questionState.endTime + breakTimeSeconds;
					continue; // Move to next question
				}

				// Update timing if not already set
				if (!questionState.timingCalculated) {
					questionState.startTime = currentStartTime;
					questionState.endTime = currentStartTime + duration;
					questionState.timingCalculated = true;
				}

				const startTime = questionState.startTime;
				const endTime = questionState.endTime;

				// Check if it's time to show the question (trigger 1 second early for responsiveness)
				if (elapsedSeconds + 1 >= startTime && elapsedSeconds < endTime && !questionState.shown && !questionState.answered) {
					showPatient(patientId, question);
					questionState.shown = true;
				}

				// Update patient timer if question is active
				if (questionState.shown && !questionState.hidden && !questionState.answered) {
					updatePatientTimer(patientId, elapsedSeconds, startTime, duration);
				}

				// Check if it's time to hide the question (trigger 1 second early for responsiveness)
				if (elapsedSeconds + 1 >= endTime && !questionState.hidden && !questionState.answered) {
					// Question timed out - apply timeout impacts (fire and forget)
					handleQuestionTimeout(questionId, patientId);
					questionState.hidden = true;
					questionState.timedOut = true;
					// Move to next question after break time
					currentStartTime = endTime + breakTimeSeconds;
					continue;
				}

				// If this question is still active or upcoming, stop processing further questions
				// (we only process questions sequentially)
				if (!questionState.answered && !questionState.hidden) {
					break;
				}

				// This question is done (answered or timed out), calculate next start time
				currentStartTime = endTime + breakTimeSeconds;
			}
		});
	}

	const updatePatientCount = () => {
		$('.patient-number-text').text(activePatientsSet.size);
	}

	const handleQuestionTimeout = async (questionId, patientId) => {
		// Check if this question already timed out (prevent duplicate processing)
		if (String(questionId) in timeoutQuestionsCache) {
			hidePatient(patientId);
			return;
		}

		// Find the question to get timeout impacts
		const question = questions.find(q => {
			const qId = q.question || q.ID || q.id;
			return parseInt(qId) === parseInt(questionId);
		});

		if (!question) {
			console.error('Question not found for timeout:', questionId);
			hidePatient(patientId);
			return;
		}

		try {
			const teamCode = window.CFG.data.game_progress.team_code.toUpperCase();
			const teamPath = firebase.getTeamPath(teamCode);
			const timeoutQuestionsPath = `${teamPath}/timeout_questions`;

			// Get existing timeout questions
			const snapshot = await firebase.get(timeoutQuestionsPath);
			const timeoutQuestions = snapshot.exists() ? snapshot.val() : {};

			// Calculate elapsed time when this timeout occurred
			const now = Date.now() + serverTimeOffset;
			const elapsedSeconds = Math.floor((now - timerStart) / 1000);

			// Add new timeout
			timeoutQuestions[questionId] = {
				timed_out_at: elapsedSeconds
			};

			// Calculate new metrics if timeout has impacts
			const newMetricsState = { ...metricsState };
			if (question.timeout_impact && Array.isArray(question.timeout_impact)) {
				question.timeout_impact.forEach(impact => {
					const metricId = impact.metric;
					const value = parseInt(impact.value) || 0;

					// Initialize metric with starting value if not already set
					if (!newMetricsState[metricId] && newMetricsState[metricId] !== 0) {
						newMetricsState[metricId] = getMetricStartingValue(metricId);
					}
					newMetricsState[metricId] += value;
				});
			}

			// Save back to Firebase (timeout questions and metrics)
			// The listener will handle all local state updates for all players
			await firebase.update(teamPath, {
				timeout_questions: timeoutQuestions,
				metrics: newMetricsState
			});
		} catch (error) {
			console.error('Error handling question timeout:', error);
			// Still hide the patient even if Firebase fails
			hidePatient(patientId);
		}
	};

	const showPatient = (patientId, question, isReload = false) => {
		// Check if patient is already active
		const wasActive = activePatientsSet.has(patientId);
		const $patient = $(`.patients__container[data-patient-id="${patientId}"]`);
		const $image = $patient.find('img');
		const waitingRoomImage = question.waiting_room_image;

		$image.attr('src', waitingRoomImage.image);
		// $image.css({
		// 	'width': waitingRoomImage.size.width + 'px',
		// 	'height': waitingRoomImage.size.height + 'px'
		// });
		$patient.css({
			'left': waitingRoomImage.coordinates.left + '%',
			'top': waitingRoomImage.coordinates.top + '%',
			'height': waitingRoomImage.height_in_percent + '%'
		});
		$patient.addClass('is-active');

		// Add patient to active set and update count if it's new
		if (!wasActive) {
			activePatientsSet.add(patientId);
			updatePatientCount();
		}

		// Only show popup if it's not a page reload
		if (!isReload) {
			showPopupNewPatient(patientId);
		}
	}

	const hidePatient = (patientId) => {
		$(`.btn-open-patient[data-patient-id="${patientId}"]`).removeClass('is-active');

		// Remove patient from active set and update count
		if (activePatientsSet.has(patientId)) {
			activePatientsSet.delete(patientId);
			updatePatientCount();
		}

		hideQuestion(patientId);
		showPopupPatientLeave(patientId);
	}

	const showQuestion = (e) => {
		const patientId = $(e.currentTarget).data('patient-id');

		// Find a question for this patient where hidden is false and not answered
		const question = questions.find(question => {
			if (question.patientId !== parseInt(patientId)) {
				return false;
			}

			// Get the question ID and check its state
			const questionId = question.question || question.ID || question.id || 'unknown';
			const state = questionStates.get(questionId);

			// Return true if the question exists, is not hidden, and not answered
			return state && state.hidden === false && !state.answered;
		});

		if (!question) {
			console.error('No question found for patient:', patientId);
			return;
		}

		const questionData = window.CFG.data.questions.find(q => q.ID === question.question);
		const patient = patients.find(p => p.ID === patientId);
		const templateData = { ...question, ...questionData, ...patient };

		const $target = $("#question-page-template");
		if (!$target.length) return console.error("Template not found");

		const $templateScript = $target.html();
		const template = Handlebars.compile($templateScript);
		const compiledHtml = template(templateData);
		$elems.questionWrapper.html(compiledHtml);
		$elems.questionWrapper.attr('data-patient-id', patientId);
		$elems.questionWrapper.attr('data-question-id', question.question);

		// Attach audio event listeners directly (media events don't bubble)
		attachAudioEventListeners();

		// Adjust font size based on character count
		adjustQuestionFontSize();
		adjustAnswerTextFontSize();

		$elems.questionWrapper.addClass('is-open');
		$elems.waitingRoom.addClass('file-is-open');

		// Update timer immediately
		if (timerStart) {
			const now = Date.now() + serverTimeOffset;
			const elapsedSeconds = Math.floor((now - timerStart) / 1000);
			updateQuestionTimer(elapsedSeconds);
		}
	}

	const adjustQuestionFontSize = () => {
		const $questionElement = $('.patient__body-actions--question');
		if (!$questionElement.length) return;

		// Get the text content and count characters
		const textContent = $questionElement.text().trim();
		const charCount = textContent.length;

		// If character count is 150 or less, reset to default (remove inline style)
		if (charCount <= 150) {
			$questionElement.css('font-size', '');
			return;
		}


		const reduction = Math.floor((charCount - 95) / 50) * 8;


		$questionElement.css('font-size', '');
		const baseFontSize = parseFloat($questionElement.css('font-size')) || 20;

		const newFontSize = baseFontSize - reduction;


		const minFontSize = 20;
		const finalFontSize = Math.max(newFontSize, minFontSize);

		$questionElement.css('font-size', finalFontSize + 'px');
	}

	const adjustAnswerTextFontSize = () => {
		const $answerTextElements = $('.patient__body-actions--answer-item-text');
		if (!$answerTextElements.length) return;

		// Process each answer text element
		$answerTextElements.each(function () {
			const $answerElement = $(this);

			// Get the text content and count characters
			const textContent = $answerElement.text().trim();
			const charCount = textContent.length;

			// If character count is 150 or less, reset to default (remove inline style)
			if (charCount <= 150) {
				$answerElement.css('font-size', '');
				return;
			}

			const reduction = Math.floor((charCount - 150) / 50) * 4;

			$answerElement.css('font-size', '');
			const baseFontSize = parseFloat($answerElement.css('font-size')) || 20;

			const newFontSize = baseFontSize - reduction;

			const minFontSize = 20;
			const finalFontSize = Math.max(newFontSize, minFontSize);

			$answerElement.css('font-size', finalFontSize + 'px');
		});
	}

	const preloadAndSetImage = ($imgElement, newSrc) => {
		// Add loading class to both image and parent container
		const $container = $imgElement.parent();
		$imgElement.addClass('is-loading');
		$container.addClass('is-loading');

		// Create a temporary image to preload
		const tempImg = new Image();

		tempImg.onload = () => {
			// Once loaded, update the actual image element
			$imgElement.attr('src', newSrc);
			// Remove loading class
			$imgElement.removeClass('is-loading');
			$container.removeClass('is-loading');
		};

		tempImg.onerror = () => {
			console.error('Failed to load image:', newSrc);
			// Still update the src even if it fails, to show the broken image
			$imgElement.attr('src', newSrc);
			$imgElement.removeClass('is-loading');
			$container.removeClass('is-loading');
		};

		// Start loading the image
		tempImg.src = newSrc;
	};

	const closeCurrentAndProcessNext = () => {
		if (patientEventPopupTimeoutId) {
			clearTimeout(patientEventPopupTimeoutId);
			patientEventPopupTimeoutId = null;
		}
		if (currentPatientEventType === 'new') {
			$elems.popupNewPatient.removeClass('is-open');
		} else if (currentPatientEventType === 'leave') {
			$elems.popupPatientLeave.removeClass('is-open');
		}
		currentPatientEventType = null;
		patientEventPopupShowing = false;
		if (patientEventPopupQueue.length === 0) {
			$elems.waitingRoom.removeClass('blur');
		}
		processPatientEventQueue();
	};

	const processPatientEventQueue = () => {
		if (patientEventPopupShowing || patientEventPopupQueue.length === 0) return;
		const item = patientEventPopupQueue.shift();
		const patient = patients.find(p => p.ID === item.patientId);
		if (!patient) {
			processPatientEventQueue();
			return;
		}
		currentPatientEventType = item.type;
		patientEventPopupShowing = true;
		$elems.waitingRoom.addClass('blur');

		if (item.type === 'new') {
			$elems.popupNewPatient.find('.popup__profile-name').text(patient.full_name);
			$elems.popupNewPatient.addClass('is-open');
			const $img = $elems.popupNewPatient.find('.popup__profile img');
			preloadAndSetImage($img, patient.profile_image);
		} else {
			$elems.popupPatientLeave.addClass('is-open');
			$elems.popupPatientLeave.find('#popup-patient-leave-name').text(patient.name);
			const $img = $elems.popupPatientLeave.find('.popup__patient-name .icon img');
			preloadAndSetImage($img, patient.profile_image);
		}

		patientEventPopupTimeoutId = setTimeout(() => {
			closeCurrentAndProcessNext();
		}, 10000);
	};

	const closeNotificationAndProcessNext = () => {
		if (notificationPopupTimeoutId) {
			clearTimeout(notificationPopupTimeoutId);
			notificationPopupTimeoutId = null;
		}
		$elems.popupNotification.removeClass('is-open');
		notificationPopupShowing = false;
		if (notificationPopupQueue.length === 0) {
			$elems.waitingRoom.removeClass('blur');
		}
		processNotificationQueue();
	};

	const processNotificationQueue = () => {
		if (notificationPopupShowing || notificationPopupQueue.length === 0) return;
		const item = notificationPopupQueue.shift();
		const patient = patients.find(p => p.ID === item.patientId);
		if (!patient) {
			processNotificationQueue();
			return;
		}
		notificationPopupShowing = true;
		$elems.popupNotification.removeClass(['is-leaving', 'is-enter']);
		$elems.popupNotification.find('.title').text(item.type === 'enter' ? window.CFG.strings.new_patient : window.CFG.strings.patient_left);
		$elems.popupNotification.find('.name').text(patient.full_name);
		$elems.popupNotification.addClass(item.type === 'enter' ? 'is-enter' : 'is-leaving');
		$elems.popupNotification.addClass('is-open');

		notificationPopupTimeoutId = setTimeout(() => {
			closeNotificationAndProcessNext();
		}, 10000);
	};

	const showPopupNewPatient = (patientId) => {
		const patient = patients.find(patient => patient.ID === patientId);
		if (!patient) {
			console.error('Patient not found:', patientId);
			return;
		}

		const isQuestionOpen = $elems.waitingRoom.hasClass('file-is-open');
		const isPatientResultOpen = $elems.popupPatientResult.hasClass('is-open');
		const isWorkAroundResultOpen = $elems.popupWorkaroundResult.hasClass('is-open');
		if (isQuestionOpen || isPatientResultOpen || isWorkAroundResultOpen) {
			notificationPopupQueue.push({ type: 'enter', patientId });
			processNotificationQueue();
		}
		else {
			// Queue and show one after another
			patientEventPopupQueue.push({ type: 'new', patientId });
			processPatientEventQueue();
		}
	}

	const showPopupPatientLeave = (patientId) => {
		const patient = patients.find(patient => patient.ID === patientId);
		if (!patient) {
			console.error('Patient not found:', patientId);
			return;
		}

		const isQuestionOpen = $elems.waitingRoom.hasClass('file-is-open');
		const isPatientResultOpen = $elems.popupPatientResult.hasClass('is-open');
		const isWorkAroundResultOpen = $elems.popupWorkaroundResult.hasClass('is-open');
		if (isQuestionOpen || isPatientResultOpen || isWorkAroundResultOpen) {
			notificationPopupQueue.push({ type: 'leaving', patientId });
			processNotificationQueue();
		}
		else {
			// Queue and show one after another
			patientEventPopupQueue.push({ type: 'leave', patientId });
			processPatientEventQueue();
		}
	}

	const showPopupPatientResult = (questionId, answerId, patientFullName) => {
		const question = window.CFG.data.questions.find(question => parseInt(question.ID) === parseInt(questionId));

		if (!question) {
			console.error('Question not found:', questionId, answerId);
			return;
		}

		const answer = question.answers.find(answer => answer.id === answerId);

		if (!answer) {
			console.error('Answer not found:', questionId, answerId);
			return;
		}

		const $image = $elems.popupPatientResult.find('#popup-result-img');
		if(answer.image) {
			$image.hide();
			$image.one('load', function() {
				$image.show();
			});
			$image.attr('src', answer.image);
			// Cached images may already be complete (load event may not fire)
			if ($image[0].complete) {
				$image.show();
			}
		} else {
			$image.attr('src', `${window.CFG.theme_url}/assets/images/no-image.png`);
			$image.show();
		}

		$elems.popupPatientResult.find('#popup-result-patient-name').text(patientFullName || '');
		$elems.popupPatientResult.find('#you-chose-answer-letter').text(answer.letter + ':');
		$elems.popupPatientResult.find('#you-chose-answer-text').text(answer.answer);
		$elems.popupPatientResult.find('.popup__description').html(answer.feedback);

		// Hide all result items by default
		$elems.popupPatientResult.find('.popup__result-item').hide();

		let hasImpacts = false;
		if (answer.impacts) {
			answer.impacts.forEach(impact => {
				// Only show if value is not 0
				if (parseInt(impact.value) !== 0) {
					hasImpacts = true;
					const $item = $elems.popupPatientResult.find('.popup__result-item[data-metric-id="' + impact.metric + '"]');
					$item.find('.number').text((impact.value >= 0 ? '+' : '') + impact.value);

					const metric = window.CFG.data.metrics.find(metric => metric.ID === impact.metric);
					if (impact.value >= 0 && metric.positive_color) {
						$item.css('background', metric.positive_color);
					} else if (impact.value < 0 && metric.negative_color) {
						$item.css('background', metric.negative_color);
					}

					$item.show(); // Show only items with non-zero impacts
				}
			});
		}

		// Hide or show the entire result section based on whether there are impacts
		if (hasImpacts) {
			$elems.popupPatientResult.find('.popup__result').show();
		} else {
			$elems.popupPatientResult.find('.popup__result').hide();
		}

		$elems.popupPatientResult.addClass('is-open');
		$elems.waitingRoom.addClass('blur');
	}

	const hideQuestion = (patientId = null) => {
		const currentPatientId = $elems.questionWrapper.attr('data-patient-id');
		if (patientId && currentPatientId != patientId) {
			return;
		}

		// Pause audio if playing
		const $audio = $('#background-information-audio')[0];
		if ($audio && !$audio.paused) {
			$audio.pause();
			resetAudioButton();
		}

		if (waitingRoom.hasClass('dossier-is-open')) {
			hideFile();
		} else {
			$elems.questionWrapper.removeClass('is-open');
			$elems.waitingRoom.removeClass('file-is-open');
			$elems.fileWrapper.removeClass('is-open');
			$elems.waitingRoom.removeClass('dossier-is-open');

			hidePopupWarningWorkaround();
		}
	}

	const hidePopupNewPatient = () => {
		if (currentPatientEventType === 'new') {
			closeCurrentAndProcessNext();
		} else {
			$elems.popupNewPatient.removeClass('is-open');
			$elems.waitingRoom.removeClass('blur');
		}
	};

	const hidePopupPatientLeave = () => {
		if (currentPatientEventType === 'leave') {
			closeCurrentAndProcessNext();
		} else {
			$elems.popupPatientLeave.removeClass('is-open');
			$elems.waitingRoom.removeClass('blur');
		}
	};

	const hidePopupNotification = () => {
		if (notificationPopupShowing) {
			closeNotificationAndProcessNext();
		} else {
			$elems.popupNotification.removeClass('is-open');
			$elems.waitingRoom.removeClass('blur');
		}
	};

	const hidePopupPatientResult = () => {
		$elems.popupPatientResult.removeClass('is-open');
		$elems.waitingRoom.removeClass('blur');
	}

	const openCareDossier = (patientId, questionId) => {
		const patient = patients.find(patient => patient.ID === parseInt(patientId));
		const question = window.CFG.data.questions.find(question => question.ID === parseInt(questionId));

		$('.file__header-title-name').text(patient.name);
		$('.file__header-title-description').text(question.question);

		$elems.questionWrapper.removeClass('is-open');
		$elems.fileWrapper.addClass('is-open').attr('data-question-id', questionId);
		$elems.waitingRoom.addClass('dossier-is-open');

		// Hide all files first
		$('.file__contentList-item, .file__content-item').hide();

		// Show/hide patient tabs based on whether they have care files
		$('.btn-patient-tab').each(function () {
			const $tab = $(this);
			const tabPatientId = $tab.data('patient-id');
			const hasCareFiles = $(`.file__contentList-item[data-patient-id="${tabPatientId}"][data-file-type="care"]`).length > 0;

			if (hasCareFiles) {
				$tab.show();
			} else {
				$tab.hide();
			}
		});

		// Initialize patient tabs - set the current patient as active
		$('.btn-patient-tab').removeClass('is-active').hide();
		$(`.btn-patient-tab[data-patient-id="${patientId}"]`).addClass('is-active').show();

		// Show corresponding profile image
		$('.file__profile').removeClass('is-active');
		$(`.file__profile[data-patient-id="${patientId}"]`).addClass('is-active');

		// Show only care files for the current patient
		$(`.file__contentList-item[data-patient-id="${patientId}"][data-file-type="care"], .file__content-item[data-patient-id="${patientId}"][data-file-type="care"]`).show();

		showWorkaroundButton(question);
	}

	const openCureDossier = (patientId, questionId) => {
		const patient = patients.find(patient => patient.ID === parseInt(patientId));
		const question = window.CFG.data.questions.find(question => question.ID === parseInt(questionId));

		$('.file__header-title-name').text(patient.name);
		$('.file__header-title-description').text(question.question);

		$elems.questionWrapper.removeClass('is-open');
		$elems.fileWrapper.addClass('is-open').attr('data-question-id', questionId);
		$elems.waitingRoom.addClass('dossier-is-open');

		// Hide all files first
		$('.file__contentList-item, .file__content-item').hide();

		// Show/hide patient tabs based on whether they have cure files
		$('.btn-patient-tab').each(function () {
			const $tab = $(this);
			const tabPatientId = $tab.data('patient-id');
			const hasCureFiles = $(`.file__contentList-item[data-patient-id="${tabPatientId}"][data-file-type="cure"]`).length > 0;

			if (hasCureFiles) {
				$tab.show();
			} else {
				$tab.hide();
			}
		});

		// Initialize patient tabs - set the current patient as active
		$('.btn-patient-tab').removeClass('is-active').hide();
		$(`.btn-patient-tab[data-patient-id="${patientId}"]`).addClass('is-active').show();

		// Show corresponding profile image
		$('.file__profile').removeClass('is-active');
		$(`.file__profile[data-patient-id="${patientId}"]`).addClass('is-active');

		// Show only cure files for the current patient
		$(`.file__contentList-item[data-patient-id="${patientId}"][data-file-type="cure"], .file__content-item[data-patient-id="${patientId}"][data-file-type="cure"]`).show();

		showWorkaroundButton(question);
	}

	const showWorkaroundButton = (question) => {
		const questionId = question.ID;

		// Check if workaround has already been used for this question
		const hasWorkaround = String(questionId) in workaroundResultsCache;

		if (hasWorkaround) {
			// Hide the workaround button wrapper
			$elems.workaroundButtonWrapper.hide();
		} else {
			// Show the workaround button wrapper and set data
			$elems.workaroundButtonWrapper.show();
			$elems.btnOpenWorkaroundWarning.attr('data-question-id', questionId);
			$elems.workaroundButtonText.text(question.workaround_button_title);
		}
	}

	const showEndScreen = () => {
		// Update metrics display
		$('.result__statistic-item').each(function () {
			const $item = $(this);
			const metricId = $item.data('metric-id');
			const metricValue = metricsState[metricId] !== undefined ? metricsState[metricId] : 0;
			$item.find('[data-metric-number]').text(metricValue);
		});

		// Calculate total questions and answered questions
		const totalQuestions = questions.length;
		const answeredCount = Object.keys(answeredQuestionsCache).length;

		// Update questions display
		$('.result__statistic-questions .answered-count').text(answeredCount);
		$('.result__statistic-questions .total-count').text(`/ ${totalQuestions}`);

		$elems.endScreen.addClass('is-open');
	}

	const openWorkaroundWarning = () => {
		const questionId = $elems.btnOpenWorkaroundWarning.attr('data-question-id');
		const question = window.CFG.data.questions.find(question => question.ID === parseInt(questionId));
		$elems.popupWarningWorkaround.find('.popup__title').text(question.workaround_warning_title);
		$elems.popupWarningWorkaround.find('.popup__description').html(question.workaround_warning_explanation);
		$elems.btnContinueWorkaround.text(question.workaround_warning_button);

		$elems.popupWarningWorkaround.addClass('is-open');
		$elems.waitingRoom.addClass('blur');
	}

	const continueWorkaround = async () => {
		const questionId = parseInt($elems.btnOpenWorkaroundWarning.attr('data-question-id'));
		const $button = $elems.btnContinueWorkaround;

		if (!questionId) {
			console.error('No question ID found');
			return;
		}

		// Disable button during save
		$button.prop('disabled', true);

		try {
			// Save to Firebase
			const teamCode = window.CFG.data.game_progress.team_code.toUpperCase();
			const teamPath = firebase.getTeamPath(teamCode);
			const workaroundResultsPath = `${teamPath}/workaround_results`;

			// Get existing workaround results
			const snapshot = await firebase.get(workaroundResultsPath);
			const workaroundResults = snapshot.exists() ? snapshot.val() : {};

			// Add new workaround result (using questionId as key)
			workaroundResults[questionId] = true;

			// Get the question to access workaround impacts
			const question = window.CFG.data.questions.find(q => parseInt(q.ID) === questionId);

			// Calculate new metrics if workaround has impacts
			const newMetricsState = { ...metricsState };
			if (question && question.workaround_impacts) {
				question.workaround_impacts.forEach(impact => {
					const metricId = impact.metric;
					const value = parseInt(impact.value) || 0;

					// Initialize metric with starting value if not already set
					if (!newMetricsState[metricId] && newMetricsState[metricId] !== 0) {
						newMetricsState[metricId] = getMetricStartingValue(metricId);
					}
					newMetricsState[metricId] += value;
				});
			}

			// Save back to Firebase
			await firebase.update(teamPath, {
				workaround_results: workaroundResults,
				metrics: newMetricsState
			});

			$button.prop('disabled', false);

			// Close the warning popup
			$elems.popupWarningWorkaround.removeClass('is-open');

		} catch (error) {
			console.error('Error submitting workaround:', error);
			$button.prop('disabled', false);
		}
	}

	const hidePopupWarningWorkaround = () => {
		$elems.popupWarningWorkaround.removeClass('is-open');
		$elems.waitingRoom.removeClass('blur');
		
	}

	const hidePopupWorkaroundResult = () => {
		$elems.popupWorkaroundResult.removeClass('is-open');
		$elems.waitingRoom.removeClass('blur');
	}

	const hideFile = () => {
		$elems.fileWrapper.removeClass('is-open').removeAttr('data-question-id');
		$elems.waitingRoom.removeClass('dossier-is-open');
		$elems.questionWrapper.addClass('is-open');
	}

	const expandFile = (e) => {
		const $clickedItem = $(e.currentTarget).closest('.file__content-item');
		const isAlreadyExpanded = $clickedItem.hasClass('is-expanded');


		$('.file__content-item').removeClass('is-expanded');


		if (!isAlreadyExpanded) {
			$clickedItem.addClass('is-expanded');
		}
	}

	const showFileContent = (e) => {
		const $clickedListItem = $(e.currentTarget);

		// Get the data attributes from the clicked list item
		const patientId = $clickedListItem.data('patient-id');
		const fileId = $clickedListItem.data('file-id');
		const fileType = $clickedListItem.data('file-type');

		// Find the corresponding file content item
		const $targetContentItem = $(`.file__content-item[data-patient-id="${patientId}"][data-file-id="${fileId}"][data-file-type="${fileType}"]`);

		// Remove is-expanded from all file__content-item elements
		$('.file__content-item').removeClass('is-expanded');

		// Add is-expanded to the matching file content item
		$targetContentItem.addClass('is-expanded');
	}

	const switchPatientTab = () => {
		return;
		// const $clickedTab = $(e.currentTarget);
		// const patientId = $clickedTab.data('patient-id');

		// // Update active tab
		// $('.btn-patient-tab').removeClass('is-active');
		// $clickedTab.addClass('is-active');

		// // Show corresponding profile image
		// $('.file__profile').removeClass('is-active');
		// $(`.file__profile[data-patient-id="${patientId}"]`).addClass('is-active');

		// // Determine which file type is currently being shown (care or cure)
		// // by checking which files are currently visible
		// const $visibleFiles = $('.file__contentList-item:visible').first();
		// const fileType = $visibleFiles.length > 0 ? $visibleFiles.data('file-type') : 'care';

		// // Hide all files first
		// $('.file__contentList-item, .file__content-item').hide();

		// // Show only files for the selected patient and file type
		// $(`.file__contentList-item[data-patient-id="${patientId}"][data-file-type="${fileType}"]`).show();
		// $(`.file__content-item[data-patient-id="${patientId}"][data-file-type="${fileType}"]`).show();

		// // Remove is-expanded from all items when switching patient
		// $('.file__content-item').removeClass('is-expanded');
	}

	const updateTimerDisplay = (remainingSeconds) => {
		$elems.timerDisplay.text(formatTime(remainingSeconds));

		// Calculate percentage for visual indicator (0-100)
		// 0 = timer just started, 100 = timer ended
		const timerDuration = (parseInt(window.CFG.data.timer) || 30) * 60; // Convert minutes to seconds (default 30 minutes)
		const percentage = Math.max(0, Math.min(100, Math.round(((timerDuration - remainingSeconds) / timerDuration) * 100)));

		// Set data attribute and class with actual percentage value (updates every second)
		$elems.timerIcon.attr('data-percentage', percentage);
		$elems.timerIcon.removeClass((index, className) => {
			return (className.match(/\bat-\d+\b/g) || []).join(' ');
		});
		$elems.timerIcon.addClass(`at-${percentage}`);
	}

	const updateGameProgress = async (field) => {
		$.ajax({
			url: window.CFG.ajax_url,
			type: 'POST',
			data: {
				action: 'update_game_progress',
				field: field,
				nonce: window.CFG.nonce,
			},
		}).done(() => {

		}).fail((xhr, status, error) => {
			console.error('Error updating game progress:', error);
		});
	};

	const startCountdown = async (timerStartTime, timerShouldEnd) => {
		// Validate timestamps
		if (!timerStartTime || typeof timerStartTime !== 'number' || !timerShouldEnd || typeof timerShouldEnd !== 'number') {
			console.error('Invalid timer timestamps');
			return;
		}

		// Prevent starting countdown multiple times with same values
		if (timerStarted && timerInterval && timerStart === timerStartTime) {
			return;
		}

		// Clear any existing interval (in case of timer reset)
		if (timerInterval) {
			clearInterval(timerInterval);
			timerInterval = null;
			// Reset question states so they can be shown again
			questionStates.clear();
			eventStates.clear();
			teamPlayerIds = null;
		}

		timerStarted = true;
		timerStart = timerStartTime;
		previousElapsedSeconds = -1; // Reset elapsed time counter
		gameFinished = false; // Reset game finished flag

		// Get server time offset once for accurate timekeeping
		const serverNow = await firebase.getServerTime();
		serverTimeOffset = serverNow - Date.now();

		// Fetch team players for "one random player per event" (deterministic pick)
		const teamCode = window.CFG.data.game_progress.team_code.toUpperCase();
		const teamPath = firebase.getTeamPath(teamCode);
		try {
			const playersSnap = await firebase.get(teamPath + '/players');
			const playersData = playersSnap.exists() ? playersSnap.val() : {};
			teamPlayerIds = Object.keys(playersData).sort();
		} catch (e) {
			teamPlayerIds = [];
		}

		// Update timer function - recalculates on each tick to stay accurate
		const updateTimer = () => {
			// Get current server time using the offset
			const now = Date.now() + serverTimeOffset;
			const remainingSeconds = Math.max(0, Math.floor((timerShouldEnd - now) / 1000));

			// Calculate elapsed seconds since timer started
			const elapsedSeconds = Math.floor((now - timerStart) / 1000);

			updateTimerDisplay(remainingSeconds);

			// Update question timer if question or file is open
			if ($elems.questionWrapper.hasClass('is-open') || $elems.fileWrapper.hasClass('is-open')) {
				updateQuestionTimer(elapsedSeconds);
			}

			// Update event timer if event popup is open
			if ($elems.eventPopup.hasClass('is-open')) {
				updateEventTimer(elapsedSeconds);
			}

			// Only check questions/events if elapsed time has changed (avoid duplicate logs)
			if (elapsedSeconds !== previousElapsedSeconds) {
				previousElapsedSeconds = elapsedSeconds;
				checkQuestionTimings(elapsedSeconds);
				checkEventTimings(elapsedSeconds);
			}

			if (remainingSeconds <= 0 && !gameFinished) {
				gameFinished = true;
				clearInterval(timerInterval);
				timerInterval = null;
				showEndScreen();
				updateGameProgress('finish_game');
			}
		};

		// Display initial time
		updateTimer();

		// Update every second - recalculates to stay accurate even when tab is inactive
		timerInterval = setInterval(updateTimer, 1000);
	}

	const setTimer = async () => {
		const teamCode = window.CFG.data.game_progress.team_code.toUpperCase();
		const teamPath = firebase.getTeamPath(teamCode);
		const timerStartPath = teamPath + '/timer_start';

		// Check if timer already exists
		const snapshot = await firebase.get(timerStartPath);

		if (!snapshot.exists()) {
			// Timer doesn't exist - set both timer_start and timer_should_end
			// Get current server time to calculate end time
			const serverTime = await firebase.getServerTime();
			const timerDuration = (parseInt(window.CFG.data.timer) || 30) * 60 * 1000; // Convert to milliseconds
			const endTime = serverTime + timerDuration;

			// Set both values atomically
			await firebase.update(teamPath, {
				timer_start: firebase.serverTimestamp(),
				timer_should_end: endTime
			});

			updateGameProgress('start_game');
		}

		// Don't start countdown here - let the Firebase listener handle it
		// This ensures we always use the actual server timestamp
	}

	const onTeamAttributeChanged = async (event, eData) => {
		const data = eData.data;

		// Only start countdown if:
		// 1. We have valid timer values
		// 2. Timer hasn't been started yet, OR
		// 3. Timer values have changed (e.g., game reset)
		if (data.timer_start && data.timer_should_end) {
			const timerChanged = lastTimerStartValue !== data.timer_start ||
				lastTimerEndValue !== data.timer_should_end;

			if (!timerStarted || timerChanged) {

				lastTimerStartValue = data.timer_start;
				lastTimerEndValue = data.timer_should_end;

				await startCountdown(data.timer_start, data.timer_should_end);
			}
		}
	}

	const onAnsweredQuestionAdded = async (event, eData) => {
		const data = eData.data;
		const questionId = parseInt(data.question_id);
		const answerId = data.answer_id;
		const answeredAt = data.answered_at; // May be undefined for old format

		// Find the question in local questions array to get patientId
		const question = questions.find(q => {
			const qId = q.question || q.ID || q.id;
			return parseInt(qId) === questionId;
		});

		if (!question) {
			console.error('Question not found in questions array:', questionId);
			return;
		}

		const patientId = question.patientId;

		// Get the answer object to access impacts from global questions data
		const globalQuestion = window.CFG.data.questions.find(q => parseInt(q.ID) === questionId);
		if (globalQuestion) {
			const answer = globalQuestion.answers.find(a => a.id === answerId);

			// Update metrics if answer has impacts (applies to all players)
			if (answer && answer.impacts) {
				updateMetrics(answer.impacts);
			}
		}

		// Update local cache (use string key to match Firebase format)
		// Use the answered_at from Firebase if available, otherwise calculate it
		let answeredAtTime = answeredAt;
		if (answeredAtTime === undefined && timerStart) {
			const now = Date.now() + serverTimeOffset;
			answeredAtTime = Math.floor((now - timerStart) / 1000);
		}

		answeredQuestionsCache[String(questionId)] = {
			answer_id: answerId,
			answered_at: answeredAtTime
		};

		// Mark question as answered in local state and record when it was answered
		const state = questionStates.get(questionId);
		if (state) {
			state.answered = true;
			// Use the timestamp from Firebase for consistency across all players
			if (answeredAtTime !== null && answeredAtTime !== undefined) {
				state.answeredAt = answeredAtTime;
			}
		}

		const patientFullName = patients.find(p => p.ID === patientId)?.full_name;

		// Show popup result
		showPopupPatientResult(data.question_id, data.answer_id, patientFullName);

		// Remove is-active class from patient button (applies to all players)
		$(`.btn-open-patient[data-patient-id="${patientId}"]`).removeClass('is-active');

		// Remove patient from active set and update count (applies to all players)
		if (activePatientsSet.has(patientId)) {
			activePatientsSet.delete(patientId);
			updatePatientCount();
		}

		// Check if the currently opened question matches the answered question
		// Only close the question wrapper if it matches
		const currentQuestionId = parseInt($elems.questionWrapper.attr('data-question-id'));
		if (currentQuestionId === questionId) {
			// Close question wrapper
			hideQuestion(patientId);
		}
	}

	const onWorkAroundResult = async (event, eData) => {
		const data = eData.data;
		const questionId = parseInt(data.question_id);

		// Update local cache (use string key to match Firebase format)
		workaroundResultsCache[String(questionId)] = true;

		// Get the question from global questions data
		const question = window.CFG.data.questions.find(q => parseInt(q.ID) === questionId);
		if (!question) {
			console.error('Question not found:', questionId);
			return;
		}

		// Update metrics if workaround has impacts (applies to all players)
		if (question.workaround_impacts) {
			updateMetrics(question.workaround_impacts);
		}

		// Prepare popup with question data
		$elems.popupWorkaroundResult.find('.popup__title').text(question.workaround_feedback_title);
		$elems.popupWorkaroundResult.find('.popup__description').html(question.workaround_feedback_explanation);

	// Hide all result items by default
	$elems.popupWorkaroundResult.find('.popup__result-item').hide();

	let hasImpacts = false;
	if (question.workaround_impacts) {
		question.workaround_impacts.forEach(impact => {
			// Only show if value is not 0
			if (parseInt(impact.value) !== 0) {
				hasImpacts = true;
				const $item = $elems.popupWorkaroundResult.find('.popup__result-item[data-metric-id="' + impact.metric + '"]');
				$item.find('.number').text((impact.value >= 0 ? '+' : '') + impact.value);

				const metric = window.CFG.data.metrics.find(metric => metric.ID === impact.metric);
				if (impact.value >= 0 && metric.positive_color) {
					$item.css('background', metric.positive_color);
				} else if (impact.value < 0 && metric.negative_color) {
					$item.css('background', metric.negative_color);
				}
				$item.show(); // Show only items with non-zero impacts
			}
		});
	}

	// Hide or show the entire result section based on whether there are impacts
	if (hasImpacts) {
		$elems.popupWorkaroundResult.find('.popup__result').show();
	} else {
		$elems.popupWorkaroundResult.find('.popup__result').hide();
	}

		// Check if the currently opened question matches the workaround question
		const currentQuestionId = parseInt($elems.questionWrapper.attr('data-question-id'));
		if (currentQuestionId === questionId) {
			// Close the warning popup if it's open for this question
			hidePopupWarningWorkaround();

			// Hide the workaround button since it's been used
			$elems.workaroundButtonWrapper.hide();
		}

		// Show the result popup (applies to all players)
		$elems.popupWorkaroundResult.addClass('is-open');
		$elems.waitingRoom.addClass('blur');
	}

	const onQuestionTimedOut = async (event, eData) => {
		const data = eData.data;
		const questionId = parseInt(data.question_id);
		const timedOutAt = data.timed_out_at;

		// Update local cache (use string key to match Firebase format)
		timeoutQuestionsCache[String(questionId)] = {
			timed_out_at: timedOutAt
		};

		// Find the question to get patientId and timeout impacts
		const question = questions.find(q => {
			const qId = q.question || q.ID || q.id;
			return parseInt(qId) === questionId;
		});

		if (!question) {
			console.error('Question not found for timeout:', questionId);
			return;
		}

		const patientId = question.patientId;

		// Update metrics if timeout has impacts (applies to all players)
		if (question.timeout_impact && Array.isArray(question.timeout_impact)) {
			updateMetrics(question.timeout_impact);
		}

		// Mark question as timed out in local state
		const state = questionStates.get(questionId);
		if (state) {
			state.hidden = true;
			state.timedOut = true;
		}

		// Hide patient (applies to all players)
		hidePatient(patientId);

		// Check if the currently opened question matches the timed out question
		const currentQuestionId = parseInt($elems.questionWrapper.attr('data-question-id'));
		if (currentQuestionId === questionId) {
			// Close question wrapper
			hideQuestion(patientId);
		}
	}

	// Store answered questions from Firebase
	let answeredQuestionsCache = {};

	// Store workaround results from Firebase
	let workaroundResultsCache = {};

	// Store timeout results from Firebase
	let timeoutQuestionsCache = {};

	// Store metrics state
	let metricsState = {};

	// Load answered questions from Firebase
	const getMetricStartingValue = (metricId) => {
		// metric_starting_values is an array: [{metric: 49, value: "3"}, {metric: 51, value: "5"}]
		const startingValues = window.CFG?.data?.metric_starting_values;
		if (startingValues && Array.isArray(startingValues)) {
			const metricConfig = startingValues.find(item => parseInt(item.metric) === parseInt(metricId));
			if (metricConfig) {
				return parseInt(metricConfig.value) || 0;
			}
		}
		return 0;
	};

	/**
	 * Get color for a score from threshold_colors.
	 * Supports two formats:
	 * - min_score (recommended): tiers ordered by min_score descending; first tier where score >= min_score wins.
	 *   e.g. [{ min_score: 10, color: "#81d742" }, { min_score: 5, color: "#dd9933" }, { min_score: 0, color: "#dd3333" }]
	 * - max_score (legacy): tiers ordered by max_score ascending; first tier where score <= max_score wins.
	 */
	const getColorForScore = (score, thresholdColors) => {
		if (!thresholdColors || !Array.isArray(thresholdColors) || thresholdColors.length === 0) return null;
		const numScore = parseInt(score, 10);
		if (Number.isNaN(numScore)) return null;

		const hasMin = thresholdColors.some(t => t.min_score !== undefined && t.min_score !== null);
		if (hasMin) {
			const sorted = [...thresholdColors].sort((a, b) => (parseInt(b.min_score, 10) || 0) - (parseInt(a.min_score, 10) || 0));
			const tier = sorted.find(t => numScore >= (parseInt(t.min_score, 10) || 0));
			return tier?.color || null;
		}
		const hasMax = thresholdColors.some(t => t.max_score !== undefined && t.max_score !== null);
		if (hasMax) {
			const sorted = [...thresholdColors].sort((a, b) => (parseInt(a.max_score, 10) || 0) - (parseInt(b.max_score, 10) || 0));
			const tier = sorted.find(t => numScore <= (parseInt(t.max_score, 10) || 0));
			return tier?.color || null;
		}
		return null;
	};

	const applyMetricDisplay = ($element, metricId, value) => {
		if (!$element?.length) return;
		$element.text(value);
		const metric = window.CFG?.data?.metrics?.find(m => parseInt(m.ID, 10) === parseInt(metricId, 10));
		const color = metric?.threshold_colors ? getColorForScore(value, metric.threshold_colors) : null;
		if (color) {
			let colorTrasparent;
			if(color.toUpperCase() == '#FFFFFF') {
				colorTrasparent = `${color}40`;
			}
			else {
				colorTrasparent = `${color}AA`;
			}
			$element.closest('.indicator__item').css('background', colorTrasparent);
		} else {
			$element.closest('.indicator__item').css('background', '');
		}
	};

	const updateMetrics = (impacts) => {
		if (!impacts || !Array.isArray(impacts)) return;

		impacts.forEach(impact => {
			const metricId = impact.metric;
			const value = parseInt(impact.value) || 0;

			// Initialize metric with starting value if not already set
			if (!metricsState[metricId] && metricsState[metricId] !== 0) {
				metricsState[metricId] = getMetricStartingValue(metricId);
			}
			metricsState[metricId] += value;

			// Update UI (text + threshold color)
			const $metricElement = $(`.indicator__item-content-number[data-metric-id="${metricId}"]`);
			applyMetricDisplay($metricElement, metricId, metricsState[metricId]);
		});
	};

	const loadAnsweredQuestions = async () => {
		try {
			const teamCode = window.CFG.data.game_progress.team_code.toUpperCase();
			const teamPath = firebase.getTeamPath(teamCode);
			const answeredQuestionsPath = `${teamPath}/answered_questions`;
			const workaroundResultsPath = `${teamPath}/workaround_results`;
			const timeoutQuestionsPath = `${teamPath}/timeout_questions`;
			const metricsPath = `${teamPath}/metrics`;

			// Load answered questions
			const answeredSnapshot = await firebase.get(answeredQuestionsPath);
			if (answeredSnapshot.exists()) {
				answeredQuestionsCache = answeredSnapshot.val();
			}

			// Load workaround results
			const workaroundSnapshot = await firebase.get(workaroundResultsPath);
			if (workaroundSnapshot.exists()) {
				workaroundResultsCache = workaroundSnapshot.val();
			}

			// Load timeout questions
			const timeoutSnapshot = await firebase.get(timeoutQuestionsPath);
			if (timeoutSnapshot.exists()) {
				timeoutQuestionsCache = timeoutSnapshot.val();
			}

			// Load metrics
			const metricsSnapshot = await firebase.get(metricsPath);
			if (metricsSnapshot.exists()) {
				metricsState = metricsSnapshot.val();
			}

			// Update UI with loaded or starting values for all metrics (text + threshold color)
			$('.indicator__item-content-number[data-metric-id]').each((index, element) => {
				const $element = $(element);
				const metricId = $element.data('metric-id');

				// If metric doesn't exist in state, initialize with starting value
				if (metricsState[metricId] === undefined) {
					metricsState[metricId] = getMetricStartingValue(metricId);
				}

				applyMetricDisplay($element, metricId, metricsState[metricId]);
			});
		} catch (error) {
			console.error('Error loading answered questions:', error);
		}
	};

	// Register event listener BEFORE starting Firebase listener
	bdjs.listen("bd__teamAttributeChanged", onTeamAttributeChanged);
	bdjs.listen("bd__answeredQuestionAdded", onAnsweredQuestionAdded);
	bdjs.listen("bd__workaroundResultAdded", onWorkAroundResult);
	bdjs.listen("bd__questionTimedOut", onQuestionTimedOut);

	// Now initialize and start Firebase listener
	const initialized = await firebase.init(window.CFG.data.auth_token);
	if (initialized) {
		// Load answered questions BEFORE starting timer to ensure cache is populated
		await loadAnsweredQuestions();
		await firebase.firebaseListener(window.CFG.data.game_progress.team_code.toUpperCase());
		await setTimer();
	}

	// Remove loading state after initialization
	$elems.waitingRoom.removeClass('is-loading');


	const selectAnswer = (e) => {
		const $clickedAnswer = $(e.currentTarget);

		// Remove is-selected from all answer items
		$('.patient__body-actions--answer-item').removeClass('is-selected');

		// Add is-selected to the clicked answer
		$clickedAnswer.addClass('is-selected');

		// Enable the submit button
		$('.patient__body-actions .btn-primary').prop('disabled', false);
	};

	const submitAnswer = async (e) => {
		e.preventDefault();
		const $button = $(e.currentTarget);

		// Get the selected answer
		const $selectedAnswer = $('.patient__body-actions--answer-item.is-selected');
		if (!$selectedAnswer.length) {
			console.error('No answer selected');
			return;
		}

		const answerId = $selectedAnswer.data('answer-id');
		const questionId = parseInt($elems.questionWrapper.attr('data-question-id'));

		if (!questionId || !answerId) {
			console.error('Missing question ID or answer ID');
			return;
		}

		// Find the full answer object to get impacts
		const questionData = window.CFG.data.questions.find(q => q.ID === questionId);
		const answerObject = questionData?.answers?.find(a => a.id === answerId);

		// Disable the button while submitting
		$button.prop('disabled', true).text(window.CFG.strings.submitting);

		try {
			// Save to Firebase
			const teamCode = window.CFG.data.game_progress.team_code.toUpperCase();
			const teamPath = firebase.getTeamPath(teamCode);
			const answeredQuestionsPath = `${teamPath}/answered_questions`;

			// Get existing answers
			const snapshot = await firebase.get(answeredQuestionsPath);
			const answeredQuestions = snapshot.exists() ? snapshot.val() : {};

			// Calculate elapsed time when this answer was submitted
			const now = Date.now() + serverTimeOffset;
			const elapsedSeconds = Math.floor((now - timerStart) / 1000);

			// Add new answer with timestamp
			answeredQuestions[questionId] = {
				answer_id: answerId,
				answered_at: elapsedSeconds
			};

			// Calculate new metrics for Firebase (without updating local state)
			const newMetricsState = { ...metricsState };
			if (answerObject && answerObject.impacts) {
				answerObject.impacts.forEach(impact => {
					const metricId = impact.metric;
					const value = parseInt(impact.value) || 0;

					// Initialize metric with starting value if not already set
					if (!newMetricsState[metricId] && newMetricsState[metricId] !== 0) {
						newMetricsState[metricId] = getMetricStartingValue(metricId);
					}
					newMetricsState[metricId] += value;
				});
			}

			// Save back to Firebase (answered questions and metrics)
			// The listener will handle all local state updates for all players
			await firebase.update(teamPath, {
				answered_questions: answeredQuestions,
				metrics: newMetricsState
			});
		} catch (error) {
			console.error('Error submitting answer:', error);
			$button.prop('disabled', false).text(window.CFG.strings.submit);
		}
	};

	const updateAudioButtonToPlaying = () => {
		const $button = $('.play-audio-btn');
		$button.addClass('is-playing').removeClass('is-paused');
		$button.find('.play-audio-text').hide();
		$button.find('.pause-audio-text').show();
		$button.find('.play-audio-icon').hide();
		$button.find('.pause-audio-icon').show();
	};

	const updateAudioButtonToPaused = () => {
		const $button = $('.play-audio-btn');
		$button.addClass('is-paused').removeClass('is-playing');
		$button.find('.play-audio-text').show();
		$button.find('.pause-audio-text').hide();
		$button.find('.play-audio-icon').show();
		$button.find('.pause-audio-icon').hide();
	};

	const resetAudioButton = () => {
		const $button = $('.play-audio-btn');
		$button.removeClass('is-playing is-paused');
		$button.find('.play-audio-text').show();
		$button.find('.pause-audio-text').hide();
		$button.find('.play-audio-icon').show();
		$button.find('.pause-audio-icon').hide();
	};

	const attachAudioEventListeners = () => {
		const $audio = $('#background-information-audio');
		if (!$audio.length) return;

		// Remove any existing listeners to prevent duplicates
		$audio.off('play', updateAudioButtonToPlaying);
		$audio.off('pause', updateAudioButtonToPaused);
		$audio.off('ended', resetAudioButton);

		// Attach new listeners
		$audio.on('play', updateAudioButtonToPlaying);
		$audio.on('pause', updateAudioButtonToPaused);
		$audio.on('ended', resetAudioButton);
	};

	const toggleAudio = (e) => {
		e.preventDefault();
		const $audio = $('#background-information-audio')[0];

		if (!$audio) {
			console.error('Audio element not found');
			return;
		}

		if ($audio.paused) {
			$audio.play();
		} else {
			$audio.pause();
		}
	};

	$elems.btnBackToWaitingRoom.on('click', () => hideQuestion(null));
	$elems.btnBackToQuestion.on('click', hideFile);

	$elems.btnExpand.on('click', expandFile);
	$elems.btnFileListItem.on('click', showFileContent);
	$elems.btnOpenPatient.on('click', showQuestion);

	// Patient tab switching
	$elems.fileWrapper.on('click', '.btn-patient-tab', switchPatientTab);
	$elems.btnCloseNewPatient.on('click', hidePopupNewPatient);
	$elems.btnClosePatientLeave.on('click', hidePopupPatientLeave);
	$elems.btnCloseNotification.on('click', hidePopupNotification);
	$elems.btnClosePopupPatientResult.on('click', hidePopupPatientResult);
	$elems.btnOpenWorkaroundWarning.on('click', openWorkaroundWarning);
	$elems.btnCancelWorkaround.on('click', hidePopupWarningWorkaround);
	$elems.btnContinueWorkaround.on('click', continueWorkaround);
	$elems.btnClosePopupWorkaroundResult.on('click', hidePopupWorkaroundResult);

	// Event delegation for dynamically loaded content
	$elems.questionWrapper.on('click', '.patient__body-actions--answer-item', selectAnswer);
	$elems.questionWrapper.on('click', '.play-audio-btn', toggleAudio);
	$elems.questionWrapper.on('click', '#btn-submit-answer', submitAnswer);

	// Note: Audio event listeners (play, pause, ended) are attached directly
	// in attachAudioEventListeners() after the question HTML is loaded,
	// because media events don't bubble and can't use jQuery delegation

	$elems.questionWrapper.on('click', '#btn-open-care-dossier', () => {
		const patientId = $elems.questionWrapper.attr('data-patient-id');
		const questionId = $elems.questionWrapper.attr('data-question-id');
		openCareDossier(patientId, questionId);
	});
	$elems.questionWrapper.on('click', '#btn-open-cure-dossier', () => {
		const patientId = $elems.questionWrapper.attr('data-patient-id');
		const questionId = $elems.questionWrapper.attr('data-question-id');
		openCureDossier(patientId, questionId);
	});

	screen.calculateCoverSize();

	window.addEventListener('resize', () => {
		screen.calculateCoverSize();
	});
}